<template>
	<div class="imprint">
		<router-link class="imprint__close" to="/">X</router-link>
		<div class="imprint__text" v-html="text"></div>
	</div>
</template>

<script>
import text from '../assets/impressum.md'

export default {
	data () {
		return {
			text: text
		}
	}
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
.imprint {
	position: fixed;
	background: white;
	top: 2rem;
	left: 2rem;
	padding: 2rem;
	max-height: calc(100vh - 4rem);
	width: calc(100vw - 4rem);
	overflow: auto;

	&__close {
		position: fixed;
		top: 1rem;
		left: 1rem;
		width: 3rem;
		height: 3rem;
		text-align: center;
		line-height: 3rem;
		background: black;
		font-size: 1.5rem;
		color: white !important;
		text-decoration: none;
	}

	&__text {
		max-width: 480px;
	}
}
</style>



// WEBPACK FOOTER //
// src/components/Imprint.vue